
import { Component, Vue, Prop } from 'vue-property-decorator';
import VWrapper from '@/components/shared/VWrapper.vue';
import { namespace } from 'vuex-class';
import { AxiosResponse } from 'axios';
import { Venue } from '@/interfaces/models/Venue';
import TranslationApiService from '@/api/http/TranslationApiService';
import { mixins } from 'vue-class-component';
import Notification from '@/mixins/Notification';
import { Language } from '@/enums/Language';

const venue = namespace('venue');

@Component({
  components: { VWrapper },
})
export default class Translation extends mixins(Notification) {
  @venue.State('active') public venue!: Venue;

  public sourceLang?: string = undefined;
  public targetLangs: string[] = [];

  public get languages(): Language[] {
    return Object.values(Language).filter((lang: Language) => lang !== Language.CZ);
  }

  public async translate() {
    const api = new TranslationApiService();
    this.$startLoading('translation');
    this.notifyInfo('translation.start');

    // @ts-ignore
    const res: AxiosResponse<any> = await api.translateFoodcard(this.venue._id, this.sourceLang, this.targetLangs);

    this.$stopLoading('translation');
  }
}
